




















import Vue from 'vue';
import SelectSubscribeBox from './SelectSubscribeBox.vue';
import customerVuex from '../../../../customer/vuex/common';

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    SelectSubscribeBox,
  },
  methods: {
    confirmTopic() {
      if (this.customerFilter.topics.length < 1) {
        this.$Message.warning('请选择订阅类型');
      } else {
        this.$emit('confirmTopic');
      }
    },
  },
});
